import { useBreakpoints } from "@vueuse/core";
import { computed } from "vue";
import { BREAKPOINTS } from "../utils/constants";

export function usePortalBreakpoints() {
    const breakpoints = useBreakpoints(BREAKPOINTS);

    // VueUse returns refs from these helpers
    const isDesktop = breakpoints.greaterOrEqual("desktop");
    const isMobile = breakpoints.smaller("tablet");
    const isTablet = breakpoints.between("tablet", "desktop");

    // Common layout helpers
    const splitDirection = computed(() => (isDesktop.value ? "horizontal" : "vertical"));
    const splitDefaultSize = computed(() => (isDesktop.value ? 0.3 : 0.5));

    return {
        breakpoints,
        isDesktop,
        isTablet,
        isMobile,
        splitDirection,
        splitDefaultSize,
    };
}

export type UsePortalBreakpointsReturn = ReturnType<typeof usePortalBreakpoints>;
